import sdl from '@jds/react-generated-sdl/JDSSearchResultsInternal';
import type { JDSSearchResultsInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSSearchResultsInternalProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { appearance = 'normal', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { appearance, ...rest },
    'JDSSearchResultsInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const SearchResultsInternal = withLogic(
  Component
) as React.FC<JDSSearchResultsInternalProps> & { slotName?: string };

SearchResultsInternal.displayName = 'SearchResultsInternal';
SearchResultsInternal.slotName = 'jds_search_results_internal';

export { SearchResultsInternal, type JDSSearchResultsInternalProps };
